import { render } from "./audit-product-details.vue?vue&type=template&id=59627dd6&scoped=true&ts=true"
import script from "./audit-product-details.vue?vue&type=script&lang=ts"
export * from "./audit-product-details.vue?vue&type=script&lang=ts"

import "./audit-product-details.vue?vue&type=style&index=0&id=59627dd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59627dd6"]])

export default __exports__